import React from "react";
import "../../styles/Login.css";
import LoginForm from "../../forms/LoginForm";

const Login = () => (
  <section className="min-h-screen flex items-center justify-center bg-gray-100">
    <div className="bg-white shadow-lg rounded-lg p-8 w-full max-w-md">
      <h2 className="text-center text-2xl font-bold text-gray-800 mb-6">Admin Login</h2><hr/>
      <LoginForm />
    </div>
  </section>
);

export default Login;
